export const API_ROOT = process.env.REACT_APP_API_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const avatarUrl = (firstName) =>
    `https://ui-avatars.com/api/?name=${firstName}&background=${getColorByFirstLetter(
        firstName
    )}`;

function getColorByFirstLetter(word) {
    const colors = [
        "FEF4FF", // purple
        "F6FAFF", // blue
        "F5F8FF", // highlights
        "EBEFF7", // hover
        "F6F6F6", // gray
        "D3D5DB", // stroke
    ];

    try {
        const firstLetter = word.charAt(0).toUpperCase(); // Get the first letter and convert it to uppercase
        const alphabetPosition = firstLetter.charCodeAt(0) - 65; // Get position in alphabet (A=0, B=1, ..., Z=25)
        const colorIndex = Math.floor(alphabetPosition / (26 / colors.length)); // Divide alphabet by number of colors

        return colors[colorIndex];
    } catch (err) {
        console.log(err);
        return colors[0];
    }
}
